import { render, staticRenderFns } from "./termCondition.vue?vue&type=template&id=a89387f8&scoped=true"
import script from "./termCondition.vue?vue&type=script&lang=js"
export * from "./termCondition.vue?vue&type=script&lang=js"
import style0 from "./termCondition.vue?vue&type=style&index=0&id=a89387f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89387f8",
  null
  
)

export default component.exports